<template>
    <div class="row text-center pa-1 mt-n2" id="news">
        <v-container style="max-width: 1380px">
            <v-layout class="mx-auto">
                <v-row cols="12" xs="12" class="text-left justify-center">
                    <v-col cols="12" offset="0" class="text-left pa-6 ma-6">
                        <h1
                            class="blue--text text--darken-5"
                            aria-label="Sekcja aktualności"
                        >
                            AKTUALNOŚCI
                        </h1>
                    </v-col>
                </v-row>
            </v-layout>
            <v-layout row wrap>
                <div
                    style="margin-top: 92px;left: 0; z-index: 0;background: #DEDEDE; position: absolute;min-height:580px; width: 100%;"
                ></div>
                <v-flex xs12 md4 v-for="item in news" :key="item.title">
                    <div>
                        <v-spacer></v-spacer>
                        <article>
                            <v-card
                                class="text-center bgGray text-center black--text text--darken-2 mt-3 ml-4 mr-4 "
                                flat
                                tile
                                height="280"
                            >
                                <v-card-title
                                    style="height:80px; word-break: normal;"
                                    >{{ item.title }}</v-card-title
                                >
                                <img
                                    class="imgresponsive"
                                    :src="'/uploads/' + item.featuredImage"
                                    :alt="item.altText"
                                />
                            </v-card>
                            <v-flex md12 class="d-flex d-row">
                                <v-card
                                    flat
                                    tile
                                    class="bgGray text-left black--text text--darken-2 pa-1"
                                    min-height="350"
                                >
                                    <div
                                    text-truncate
                                        style="overflow:hidden; word-break: normal;"
                                        class="pa-6"
                                        v-html="item.post"
                                        min-height="300"
                                    ></div>
                                    <v-card-actions class="justify-end">
                                        <v-btn
                                            style="float: right;position: absolute; bottom: 0; text-align: right;"
                                            class="red--text text--darken-5 pa-6 ma-6"
                                            outlined
                                            @click="handleNewsDetails(item.id)"
                                            :href="'/news/' + item.id"
                                            :aria-label="
                                                ariaLabelTitle(item.title)
                                            "
                                            >Zobacz więcej</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </article>
                    </div>
                </v-flex>
            </v-layout>
            <div class="pa-8 text-center">
                <v-pagination
                    v-model="currentPage"
                    :length="this.page.last_page"
                    circle
                    color="blue darken-5"
                    :total-visible="6"
                    @input="handlePageChange"
                ></v-pagination>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";


export default {
    data() {
        return {
            categoryDetailPage: false,
            categorySlug: "",
            news: [],
            breadcrumbsItems: [],
            page: "",
            currentPage: 1
        };
    },

    methods: {
        ariaLabelTitle(title) {
            return "Zobacz więcej " + title;
        },
        async handleNewsDetails(id) {
            const res = await this.callApi("get", `/get_news_details/` + id);
            if (res.status == 200) {
                const newsObj = {
                    isNewsLoader: false,
                    isNewsDetails: true,
                    data: res.data
                };
                this.$store.commit("setNewsData", newsObj);
            }
        },
        async handlePageChange(value) {
            this.currentPage = value;
            const res = await this.callApi(
                "get",
                `/get_news?page=${this.currentPage}`
            );
            if (res.status == 200) {
                this.news = res.data.newsData;
                this.page = res.data.pageData;

                this.$vuetify.goTo("#news");
            }
        }
    },

    computed: {
        ...mapGetters(["setNewsData"])
    },
    async created() {
        const [news] = await Promise.all([this.callApi("get", "get_news")]);
        if (news.status == 200) {
            this.news = news.data.newsData;
            this.page = news.data.pageData;
            this.isLoading = false;
        }
    }
};
</script>
<style scoped>
.imgresponsive {
    width: 100%;
    max-width: 400px;
    height: auto;
    overflow: hidden;
    z-index: 99;
    overflow: hidden;
}

:focus {
    border: 3px solid orange;
}

.bgGray {
    background: #dedede;
}
</style>
